import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import { cn as clsx } from "../../../../helpers/react.js";
import { InputFieldContext } from "../InputFieldContext.js";
import '../../../../assets/index48.css';const badge = "_badge_ylooj_2";
const disabled = "_disabled_ylooj_23";
const text = "_text_ylooj_31";
const badgeIcon = "_badgeIcon_ylooj_41";
const s = {
  badge,
  disabled,
  text,
  badgeIcon
};
const _ComboboxBadge = forwardRef(
  ({ className, children, disabled: disabledFromProps, closeButton, ...rest }, ref) => {
    const context = useContext(InputFieldContext);
    const disabled2 = disabledFromProps ?? (context == null ? void 0 : context.disabled);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...rest,
        className: clsx(
          s.badge,
          {
            [s.disabled]: disabled2
          },
          className
        ),
        ref,
        children: [
          /* @__PURE__ */ jsx("span", { className: s.text, children }),
          closeButton
        ]
      }
    );
  }
);
export {
  _ComboboxBadge
};
